import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AllTableTabsComponent } from './all-table-tabs.component';
import { AllTableTabItemComponent } from './all-table-tab-item.component';
import { AllTableTabLabelComponent } from './all-table-tab-label.component';
import { AllTableTabBodyComponent } from './all-table-tab-body.component';

@NgModule({
  declarations: [
    AllTableTabsComponent,
    AllTableTabItemComponent,
    AllTableTabLabelComponent,
    AllTableTabBodyComponent,
  ],
  imports: [CommonModule],
  exports: [
    AllTableTabsComponent,
    AllTableTabItemComponent,
    AllTableTabBodyComponent,
    AllTableTabLabelComponent,
  ],
})
export class AllTableTabsModule {}
